import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import actions from '@src/redux/actions';
import { VBEE_DOMAIN } from '@src/configs';
import { setCookie, removeCookieFromAllSubdomains } from '@src/utils/cookie';
import {
  PRODUCT_MODE,
  PRODUCT_MODE_COOKIE_KEY,
  PRODUCT_MODE_COOKIE_EXPIRED,
} from '@src/constants/educators';

/**
 * The mode lives in two places at once: redux for this session, a cookie for
 * the next one. They have to move together, so nothing moves one on its own.
 *
 * Only educators is ever written. An absent cookie means studio — what every
 * account looked like before the mode existed — so leaving educators clears it
 * rather than recording the departure.
 */
const useProductMode = () => {
  const dispatch = useDispatch();

  return useCallback(
    (mode) => {
      dispatch(actions.layout.setProductMode(mode));

      if (mode === PRODUCT_MODE.EDUCATORS) {
        setCookie({
          cname: PRODUCT_MODE_COOKIE_KEY,
          cvalue: mode,
          domain: VBEE_DOMAIN,
          extime: PRODUCT_MODE_COOKIE_EXPIRED,
        });
        return;
      }

      removeCookieFromAllSubdomains(PRODUCT_MODE_COOKIE_KEY);
    },
    [dispatch],
  );
};

export default useProductMode;
